export const CONTAINER_MAX_WIDTH = 540;
export const BACKGROUND_DARK = '#f1f7ff';
